import React from 'react';
import { Grid, Paper, Typography} from '@mui/material';


interface FormDataProps {
    formData?: any;
}

const DisplayJson = (props: FormDataProps): JSX.Element => {

    return (
        <Grid item xs={12}>
            {
                props.formData &&
                <Paper sx={{ p: 3, maxHeight: 800, overflow: 'auto' }}>
                    <Typography variant="subtitle2" gutterBottom>
                        Raw JSON Data
                    </Typography>
                    <pre
                        style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontFamily: 'monospace',
                            fontSize: '0.85rem',
                            margin: 0
                        }}
                    >
                        {JSON.stringify(props.formData, null, 2)}
                    </pre>
                </Paper>
            }
        </Grid>
    )
}

export default DisplayJson;